<template>
    <div class="module">
        <header class="module__header--with-disclaimer">
            <a
                class="back-btn"
                @click="goBack('admin-relays')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">Create Relay</h1>
        </header>

        <section class="module__body">
            <create-relay-form />
        </section>
    </div>
</template>

<script>
import hasBackButton from '@/mixins/hasBackButton'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import CreateRelayForm from '@/components/CreateRelay.vue'

export default {
    components: {
        CreateRelayForm,
    },

    mixins: [hasBackButton, needsOrganizationSlug],
}
</script>
